export default "__VITE_ASSET__PKP$p6WJ__"